module.exports = __webpack_public_path__ + "../../../static/img/c_im_8.a5ed27b7.png";